// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__gjec2","dotSpinner":"Loader_dotSpinner__hJWLT","dotSpinnerDot":"Loader_dotSpinnerDot__YIeY3","pulse0112":"Loader_pulse0112__uyL2m"};